export function useImagePathFormatter(organizationSlug, fileName) {
    if (!fileName) {
        return null;
    }
    return `${window.appConfig.ORG_API_URL}/${organizationSlug}/files/download/${fileName}`;
}
